<template>
  <div class="loan-term-field">
    <label class="af-custom-label af-custom-label--float">{{
      $t("af:offers.filter.input.duration.label")
    }}</label>

    <b-field class="af-slider mt-2">
      <div id="termMinus" class="slider-button" @click="decrease">
        <b-icon
          icon-pack="fa"
          icon="minus"
          type="is-grey-dark"
          size="is-small"
        ></b-icon>
      </div>

      <b-slider
        id="termSlider"
        v-model="innerValue"
        class="mx-4"
        type="is-primary"
        rounded
        tooltip-always
        :min="filterSettings.durationMin"
        :max="filterSettings.durationMax"
        :step="filterSettings.durationStep"
        :custom-formatter="
          (val) => val + ' ' + $t('af:offers.filter.input.duration_unit.label')
        "
      >
      </b-slider>

      <div id="termPlus" class="slider-button" @click="increase">
        <b-icon
          icon-pack="fa"
          icon="plus"
          type="is-grey-dark"
          size="is-small"
        ></b-icon>
      </div>
    </b-field>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "TermSlider",
  props: ["value"],
  computed: {
    ...mapGetters({
      filterSettings: "filterSettings/get",
    }),
  },
  data() {
    return {
      innerValue: 0,
    };
  },
  watch: {
    value() {
      this.innerValue = this.value;
    },
    innerValue() {
      this.$emit("input", this.innerValue);
    },
  },
  created() {
    if (this.value) {
      this.innerValue = this.value;
    }
  },
  methods: {
    decrease() {
      if (
        this.innerValue - this.filterSettings.durationStep >=
        this.filterSettings.durationMin
      ) {
        this.$emit("input", this.innerValue - this.filterSettings.durationStep);
      }
    },
    increase() {
      if (
        this.innerValue + this.filterSettings.durationStep <=
        this.filterSettings.durationMax
      ) {
        this.$emit("input", this.innerValue + this.filterSettings.durationStep);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.slider-button {
  border: 1px solid #f3f5f9;
  box-shadow: 0 2px 5px rgba(42, 45, 52, 0.1);
  border-radius: 100px;
  width: 40px;
  height: 40px;
  min-width: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background: white;
}
</style>
